import { useMemo } from 'react';
import { TextArea as ZusTextArea } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { cn } from '@/utils';
type PromptAttachmentType = 'file' | 'youtube' | 'website' | 'none';
export const Label = ({
  attachmentType,
  className,
  children,
  value,
  maxLength
}: {
  attachmentType: PromptAttachmentType;
  className?: string;
  children: React.ReactNode;
  value?: string;
  maxLength?: number;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const title = useMemo(() => {
    if (attachmentType === 'none') {
      return t('build:build.ai.promptLabel.noAttachment');
    }
    return t('build:build.ai.promptLabel.withAttachment');
  }, [attachmentType, t]);
  const helperText = t('ai.message.excuse');
  return <ZusTextArea.Root className={cn('gap-3xs', className)} value={value ?? ''} maxLength={maxLength} required data-sentry-element="unknown" data-sentry-component="Label" data-sentry-source-file="Label.tsx">
      <div className="flex items-end justify-between gap-3xs">
        <ZusTextArea.Label data-sentry-element="unknown" data-sentry-source-file="Label.tsx">{title}</ZusTextArea.Label>
        {maxLength !== undefined && <ZusTextArea.TextLength />}
      </div>
      {children}
      <ZusTextArea.HelperText data-sentry-element="unknown" data-sentry-source-file="Label.tsx">{helperText}</ZusTextArea.HelperText>
    </ZusTextArea.Root>;
};